import PropTypes from "prop-types";
import SmallLoadingSpinner from "../../common/SmallLoading";

export const PopupPrimaryContact = ({ setPopup, popup, loading }) => {
  return (
    <div className="App">
      {popup.show ? (
        <div className="modal fixed w-full h-full top-0 left-0 flex items-center justify-center z-50">
          <div className="modal-overlay fixed w-full h-full overflow-y-scroll bg-gray-900 left-0 right-0 opacity-50 -z-10"></div>
          <div className="modal-container bg-white w-[40%] min-h-[40%] mx-auto rounded-xl shadow-lg overflow-y-auto">
            <div className="modal-content pt-4 text-left px-6">
              <div className="flex justify-between">
                <div>
                  <h2 className="pb-7 text-lg font-bold mr-auto">
                    Primary Contact
                  </h2>
                </div>
                <div className="modal-close cursor-pointer ">
                  <span
                    className="bg-close block cursor-pointer"
                    onClick={() => setPopup({ show: false, data: null })}
                  ></span>
                </div>
              </div>
              {loading && (
                <div className="px-5 float-left w-full pb-7">
                  <div className="preview h-48 overflow-y-scroll flex justify-center items-center">
                    <div>
                      <SmallLoadingSpinner
                        className={"w-16 h-16 border-[6px] opacity-60"}
                      />
                    </div>
                  </div>
                  <br></br>
                  <hr />
                  <div className="flex justify-between">
                    <button
                      onClick={() => setPopup({ show: false, data: null })}
                      className="w-24 px-4 py-2 mt-3 text-sm text-white transition-all duration-150 ease-linear rounded-md shadow outline-none bg-[#134d86] hover:bg-[#134d86] hover:shadow-lg focus:outline-none"
                    >
                      Close
                    </button>
                  </div>
                </div>
              )}
              {!loading && !popup.data && (
                <div className="px-5 float-left w-full pb-7">
                  <div className="flex items-center justify-center preview h-48 overflow-y-scroll">
                    <div className="mt-5 text-xl font-medium text-gray-500">
                      No primary contact found
                    </div>
                  </div>
                  <br></br>
                  <hr />
                  <div className="flex justify-between">
                    <button
                      onClick={() => setPopup({ show: false, data: null })}
                      className="w-24 px-4 py-2 mt-3 text-sm text-white transition-all duration-150 ease-linear rounded-md shadow outline-none bg-[#134d86] hover:bg-[#134d86] hover:shadow-lg focus:outline-none"
                    >
                      Close
                    </button>
                  </div>
                </div>
              )}
              {popup.data && !popup.popLoading && (
                <div className="px-5 float-left w-full pb-7">
                  <div className="preview h-48 overflow-y-scroll">
                    <div className="mt-5">
                      <div className="flex mt-4">
                        <div className="label font-bold w-40">User Name:</div>
                        <div className="value">{popup.data.user_name}</div>
                      </div>
                      <div className="flex mt-4">
                        <div className="label font-bold w-40">
                          Phone Number:
                        </div>
                        <div className="value">
                          {popup.data.country_code} &nbsp;
                          {popup.data.phone_number}
                        </div>
                      </div>
                      <div className="flex mt-4">
                        <div className="label font-bold w-40">
                          Email Address:
                        </div>
                        <div className="value">{popup.data.email_address}</div>
                      </div>
                      <div className="flex mt-4">
                        <div className="label font-bold w-40">Role:</div>
                        <div className="value">{popup.data.role}</div>
                      </div>
                    </div>
                  </div>
                  <br></br>
                  <hr />
                  <div className="flex justify-between">
                    <button
                      onClick={() => setPopup({ show: false, data: null })}
                      className="w-24 px-4 py-2 mt-3 text-sm text-white transition-all duration-150 ease-linear rounded-md shadow outline-none bg-[#134d86] hover:bg-[#134d86] hover:shadow-lg focus:outline-none"
                    >
                      Close
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

PopupPrimaryContact.propTypes = {
  setPopup: PropTypes.func.isRequired,
  popup: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};
